/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Ronnie Wisawapakorn
 * Created: 31/08/22
 */

import { useEffect } from 'react';

const usePageTitle = (title: string) => {
    useEffect(() => {
        title ? (document.title = `${title} - UTS Work Planning Tool`) : (document.title = 'UTS - Work Planning Tool');
    }, [title]);
};

export default usePageTitle;
